var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRssGrab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rss-square",
    "data-name": "Icon awesome-rss-square",
    d: "M69.643,2.25H8.357A8.357,8.357,0,0,0,0,10.607V71.893A8.357,8.357,0,0,0,8.357,80.25H69.643A8.357,8.357,0,0,0,78,71.893V10.607A8.357,8.357,0,0,0,69.643,2.25ZM19.5,69.107a8.357,8.357,0,1,1,8.357-8.357A8.357,8.357,0,0,1,19.5,69.107Zm27.428,0H40.95a1.991,1.991,0,0,1-1.992-1.851A27.866,27.866,0,0,0,12.994,41.292,1.991,1.991,0,0,1,11.143,39.3V33.322a1.988,1.988,0,0,1,2.088-1.989A37.815,37.815,0,0,1,48.917,67.019a1.988,1.988,0,0,1-1.989,2.088Zm17.938,0H58.888a2,2,0,0,1-1.99-1.922A45.773,45.773,0,0,0,13.065,23.352a2,2,0,0,1-1.922-1.99V15.385a1.988,1.988,0,0,1,2.052-1.99A55.753,55.753,0,0,1,66.856,67.055a1.988,1.988,0,0,1-1.99,2.052Z",
    transform: "translate(0.5 -1.75)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssGrab);
export default __webpack_public_path__ + "static/media/rss-grab.6d3face7df8b206ce097dcbf26e355d4.svg";
export { ForwardRef as ReactComponent };